module.exports = __webpack_public_path__ + "static/Abacus Lohnbuchhaltung LEHMANNPARTNER-f12d0d836d2ac5103e761d67d729b3c5.pdf";